import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';

// Selector to get agency data from the Redux state
const agencyBrandingData = createSelector(
  (state: any) => state.agency.agency,
  (agency) => agency
);

// Custom hook to use agency data
export const useAgency = () => {
  const agency = useSelector(agencyBrandingData);

  return agency; // Return the agency data
};
